module.exports = __webpack_public_path__ + "static/img/12.1dd8c95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/12.jpg
// module id = IClq
// module chunks = 0